import { ScreenPropCompanyConfigItem } from "~/navigation/Navigation.types";

import { CompanyConfigItem } from "./CompanyConfig.Item";

export const CompanyConfigItemScreen = (props: ScreenPropCompanyConfigItem) => {
  return <CompanyConfigItem id={props.route.params.id} onClose={() => {}} />;
};
